<template>
  <div class="card">
    <div class="card-body">
      <p>
        <small class="font-weight-bold">{{ $t('dashboard.total-submitter') }}</small>
      </p>
      <highcharts :options="chartOptions" />
    </div>
  </div>
</template>

<script>
import { format, sub } from 'date-fns'
import Api from '@/utils/Api'

export default {
  props: {
    filters: {
      type: Object,
      default: () => ({
        period: 'daily',
        startDate: sub(new Date(), { days: 30 }),
        endDate: new Date()
      })
    },
    isApply: {
      type: Boolean,
      default: () => (false)
    }
  },

  data: () => ({
    chartOptions: {
      title: false,
      credits: false,
      chart: {
        type: 'solidgauge',
        margin: [0, 0, 0, 0],
        height: 300,
        spacingBottom: 0,
        spacingTop: 0,
        spacingLeft: 0,
        spacingRight: 0,
        events: {
          render () {
            const chart = this
            const label1 = chart.series[0].dataLabelsGroup
            const label2 = chart.yAxis[0].axisGroup

            label1.translate(chart.marginRight, chart.marginBottom - label1.getBBox().height - 10)
            label2.translate(chart.marginRight, chart.marginBottom - label1.getBBox().height + 80)
          }
        }
      },
      pane: {
        startAngle: 0,
        endAngle: 360,
        background: [{
          backgroundColor: '#DEDEDE',
          outerRadius: '110%',
          innerRadius: '70%',
          borderWidth: 0
        }]
      },
      yAxis: {
        min: 0,
        max: 0,
        lineWidth: 0,
        tickPositions: [],
        title: {
          text: '',
          style: {
            color: '#18B2BD',
            fontSize: '15.5px',
            fontWeight: 'bold'
          }
        }
      },
      plotOptions: {
        solidgauge: {
          dataLabels: {
            enabled: true,
            verticalAlign: 'middle',
            useHTML: true,
            borderWidth: 0
          },
          rounded: true
        }
      },
      series: [{
        name: 'Average Submitter',
        data: [{
          radius: '110%',
          innerRadius: '70%',
          y: 0,
          dataLabels: {
            format:
            '<div style="text-align:center">' +
            '<h6 class="font-weight-bold m-0 p-0">{y}</h6>' +
            '</div>'
          },
          color: {
            linearGradient: {
              x1: 0,
              x2: 1,
              y1: 1,
              y2: 1
            },
            stops: [
              [0, '#4C2E88'],
              [1, '#18B2BD']
            ]
          }
        }
        ]
      }]
    }
  }),

  computed: {
    builtFilters () {
      return [
        `period=${this.filters.period}`,
        `startDate=${format(this.filters.startDate, 'yyyy-MM-dd')}`,
        `endDate=${format(this.filters.endDate, 'yyyy-MM-dd')}`,
        ...this.filters.organization.map(organization => `organization=${organization}`),
        ...this.filters.workLocation.map(workLocation => `workLocation=${workLocation}`),
        ...this.filters.employee.map(employee => `employeeType=${employee}`),
        ...this.filters.risk.map(risk => `risk=${risk}`)
      ].join('&')
    }
  },

  watch: {
    isApply: {
      deep: true,
      immediate: true,
      handler: 'fetch'
    }
  },

  mounted () {
    this.fetch()
  },

  methods: {
    async fetch () {
      const { data } = await Api.dashboard.averageSubmitter(this.builtFilters)
      data.averageSubmitter = Number.isInteger(data.averageSubmitter) ? data.averageSubmitter : parseFloat(data.averageSubmitter.toFixed(2))
      this.chartOptions.yAxis.max = data.totalSubmitter
      this.chartOptions.yAxis.title.text = data.totalSubmitter.toString()
      this.chartOptions.series[0].data[0].y = data.averageSubmitter
    }
  }
}
</script>
